export function parseStartParams(startParams: string) {
  const [inviteId, ...rest] = startParams.split('--');

  const restStartParams = rest.reduce((acc, val) => {
    const [key, value] = val.split('=');
    return { ...acc, [key]: value };
  }, {});
  return inviteId.includes('-')
    ? {
        invite_code: inviteId,
        ...restStartParams,
      }
    : { telegram_id: inviteId, ...restStartParams };
}
